// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3d2VA","buttons":"Footer_buttons__36pZo"};